import { BrowserQRCodeReader } from '@zxing/library';
import { BrowserMultiFormatReader } from '@zxing/library';

window.initBarcode = function() {
	const codeReader = new BrowserMultiFormatReader();

	codeReader.decodeOnceFromVideoDevice(undefined, 'video').then((result) => {
		document.getElementById('result').textContent = result.text;
	}).catch(err => console.error(err));

	return codeReader;
}
